import jwtDecode from 'jwt-decode';
import clone from 'lodash.clonedeep';
import VT from '@/store/types';

export default {
  [VT.SET_AUTH_INFO]: (state, data) => {
    // console.log(data);
    // state.roles = data.user.roles;
    state.user = data.user;
    // eslint-disable-next-line no-empty
    try {
      const session = JSON.parse(data.user.session);
      if (session) state.session = session;
      // eslint-disable-next-line no-empty
    } catch (e) {}
    // const permissions = [];
    // for (let i = 0; i < data.user.permissions.length; i++) {
    //   permissions.push(data.user.permissions[i].name);
    // }
    // for (let i = 0; i < data.user.roles.length; i++) {
    //   for (let j = 0; j < data.user.roles[i].permissions.length; j++) {
    //     if (!permissions.includes(data.user.roles[i].permissions[j].name)) {
    //       permissions.push(data.user.roles[i].permissions[j].name);
    //     }
    //   }
    // }
    // state.permissions = permissions;
    state.projects = data.projects;
    state.projectPermssions = data.projectPermssions;
    // console.log(state.user);

    if (!state.activeProjectId && state.user.project_users.length > 0) state.activeProjectId = state.user.project_users[0].project_id;
    if (!state.activeProjectId
      && state.projects.length > 0) state.activeProjectId = state.projects[0].id;
    if (state.user.project_users.length === 0
      && state.projects.length === 0) state.activeProjectId = null;

    state.hasAuthInfo = true;
  },
  [VT.SET_AUTH_TOKEN]: (state, token) => {
    state.token = token;
    state.exp = typeof state.token === 'string' && state.token.length > 0 ? jwtDecode(state.token).exp : 0;
  },
  [VT.SET_REFRESH_TOKEN]: (state, token) => {
    state.refreshToken = token;
    state.refreshTokenExp = typeof state.refreshToken === 'string'
    && state.refreshToken.length > 0 ? jwtDecode(state.refreshToken).exp : 0;
  },

  [VT.SET_ACTIVE_PROJECT]: (state, projectId) => {
    state.activeProjectId = projectId;
  },

  [VT.SET_SESSION_VAR]: (state, args) => {
    state.session = { ...state.session, ...clone(args) };
  },

};
